export function shouldListCompanyTeamMember(
  eventDayBadge: boolean | undefined,
  isOwner: boolean
): boolean {
  return eventDayBadge === true && !isOwner;
}

export function companyDirectoryPeerId(input: {
  companyId: string;
  memberUserId?: string;
}): string {
  return input.memberUserId ?? input.companyId;
}

/** Company cards have no user; member cards do. Loose shape so the mixed union type-checks. */
export function directoryMemberUserId(entry: {
  companyMembership?: unknown;
  user?: { id?: string } | object | null;
  userId?: string | null;
}): string | undefined {
  if (!entry.companyMembership) return undefined;
  const userId =
    entry.user && "id" in entry.user && typeof entry.user.id === "string"
      ? entry.user.id
      : undefined;
  return userId ?? entry.userId ?? undefined;
}

/** Personal member cards never inherit the company group's PUBLIC/PRIVATE default. */
export function personalMemberNetworkingDefault(): "BY_REQUEST" {
  return "BY_REQUEST";
}

/** Untouched auto-seed copied from the company group — safe to reset to BY_REQUEST. */
export function isUntouchedInheritedNetworking(
  type: string | undefined,
  createdAtMs: number,
  updatedAtMs: number
): boolean {
  return Boolean(
    type &&
      type !== "BY_REQUEST" &&
      Math.abs(updatedAtMs - createdAtMs) < 2000
  );
}
